import { createContext } from "react";
import LinodeAPI from "./linode";

const LinodeAPIContext = createContext<LinodeAPI>(new LinodeAPI(''));

export default LinodeAPIContext;